module.exports = __webpack_public_path__ + "img/3.c8b82f1.png";